module.exports = __webpack_public_path__ + "img/user.0eb886a0.svg";